import React, { useContext, useState, useEffect } from "react";
import PhoneInput from "react-phone-input-2";
import 'react-phone-input-2/lib/style.css';
import { getNames } from "country-list";
import { useNavigate } from "react-router-dom";
import data from "../language.json";
import languageContext from "../context/language/languageContext";
import axios from "axios";
import logo from "../assets/aica.svg";

const Login = () => {
  const navigate = useNavigate();
  const { lang, phone, setPhone } = useContext(languageContext);

  const [loader, setLoader] = useState(false);
  const [responseMessage, setResponseMessage] = useState("");
  const [pincode, setPincode] = useState("");
  const [country, setCountry] = useState("India");
  const [countries, setCountries] = useState([]);

  useEffect(() => {
    setCountries(getNames());
    checklogin();
  }, []);

  const checklogin = () => {
    const loginBool = localStorage.getItem("login");
    if (loginBool === "true") navigate("/ask");
  };

  const handleLogin = async (e) => {
    console.log(phone, "phone")
    e.preventDefault();
    // if (phone.replace(/\D/g, "").length < 10) {
    //   alert("Please enter a valid phone number");
    //   return;
    // }
    // if (pincode.length < 4 || pincode.length > 10) {
    //   alert("Please enter a valid pincode");
    //   return;
    // }

    try {
      setLoader(true);
      const response = await axios.post(
        "https://www.careplus.gopillz.com/doctor_send_otp",
        JSON.stringify({ phone}),
        {
          headers: {
            Accept: "*/*",
            "Content-Type": "application/json",
          },
        }
      );

      if (response.status === 200) {
        setResponseMessage(response.data.message || "OTP sent successfully.");
        navigate("/otp", { state: { from: "signup" } });
      } else {
        setResponseMessage(response.data.message || "Error during signup.");
      }
    } catch (error) {
      setResponseMessage(
        error.response?.data?.message || "Failed to send OTP. Please try again."
      );
    } finally {
      setLoader(false);
    }
  };

  return (
    <div className="min-h-screen bg-gradient-to-r from-[#f0f4f8] to-[#e2ecf5]">
      <div className="flex justify-center pt-20 px-4">
        <div className="flex flex-col items-center w-full max-w-md">
          <img src={logo} alt="Logo" className="w-24 h-24 mb-4" />
          <div className="bg-white shadow-2xl rounded-2xl p-8 w-full">
            <h2 className="text-2xl font-semibold text-center text-blue-900 mb-6">
              {data[lang]["auth"][1]}
            </h2>

            <form onSubmit={handleLogin} className="space-y-5">
              {/* Phone input with flags */}
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-1">Phone Number</label>
                <PhoneInput
   // Default country, change to 'in' or any ISO 3166-1 alpha-2 code if needed
  enableSearch={true}
  disableCountryCode={false} // Show country code in UI
  disableDropdown={false}   // Enable country selection
  value={phone}
  onChange={setPhone}
  inputClass="!w-full !px-4 !py-2 !text-sm !border !border-gray-300 !rounded-lg !bg-gray-50"
  buttonClass="!border-gray-300"
  containerClass="!w-full"
/>
              </div>
                            {/* Submit */}
              <button
                type="submit"
                className="w-full bg-blue-600 hover:bg-blue-700 text-white font-medium py-2 rounded-lg text-sm transition-all"
              >
                {loader ? (
                  <div className="animate-spin h-4 w-4 border-t-2 border-white border-solid mx-auto" />
                ) : (
                  <span>Proceed</span>
                )}
              </button>

              {responseMessage && (
                <div className="text-green-600 text-sm mt-2 text-center">
                  {responseMessage}
                </div>
              )}
            </form>
          </div>
        </div>
        
      </div>
      <p className="text-sm text-center mt-4">
  Don’t have an account?{" "}
  <span
    onClick={() => navigate("/signup")}
    className="text-blue-600 cursor-pointer font-medium"
  >
    Sign Up
  </span>
</p>
    </div>
  );
};

export default Login;
